import { useEffect } from "react";
import { goal } from "@flights/et-universal";
import useAlternativeFaresParams from "../../hooks/useAlternativeFaresParams.js";
import { isOfMetaOrigin } from "../../utils/marketing-url-params.js";
import useClientCachedURL from "../../hooks/useClientCachedURL.js";
import useTrackPageLoad from "../../hooks/useTrackPageLoad.js";
import useProfiler from "../../hooks/useProfiler.js";
import tph_flights_price_discrepancy_aa from "../../utils/experiments/funnel/tph_flights_price_discrepancy_aa.js";
import flights_web_apex_ancillaries_aa from "../../utils/experiments/apex/flights_web_apex_ancillaries_aa.js";
import { trackMetaChannelStagesV2 } from "../../utils/experiments/track-meta-landings-v2.js";
import { trackLoggedInUsersFD, trackLoggedInUsersFDdDot, trackLoggedInUsersFDFromTPH } from "../../utils/experiments/funnel/tph_save_flights_aa.js";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
export function useFlightDetailsDesktopEffects(params, locationSearch) {
    const isMetaUser = isOfMetaOrigin();
    const { isLoggedInAuthLow } = useProfiler();
    const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
    const trackContextEventV2 = useTrackPageLoad("flight_details");
    const { setAlternativeFaresParams, getAlternativeFaresParams } = useAlternativeFaresParams();
    useEffect(() => {
        trackContextEventV2();
        goal("flights_flight_details_page_view");
        cacheLastSuccessfulSearchUrl(params?.airports);
        trackMetaChannelStagesV2("desktop");
        flights_web_apex_ancillaries_aa.stages.flight_details();
        if (isLoggedInAuthLow()) {
            trackLoggedInUsersFD();
            trackLoggedInUsersFDdDot();
            const queryParams = new URLSearchParams(locationSearch);
            const adplat = queryParams.get("adplat");
            if (adplat && adplat.includes("wishlist-flight")) {
                trackLoggedInUsersFDFromTPH();
                tph_flights_price_discrepancy_aa.stages.all_logged_in_from_wishlist();
                tph_flights_price_discrepancy_aa.stages.web_logged_in_from_wishlist();
            }
        }
    }, []);
    useEffect(() => {
        const params = getAlternativeFaresParams();
        if (isMetaUser && !params?.searchedAt) {
            setAlternativeFaresParams("searchedAt", new Date().getTime());
        }
    }, [getAlternativeFaresParams, isMetaUser, setAlternativeFaresParams]);
}
export function useFlightDetailsDesktopEffectsCleanup({ cleanupCaParams }) {
    useEffect(() => {
        return () => {
            cleanupCaParams();
        };
    }, [cleanupCaParams]);
}
export function useFlightDetailsDesktopEffectsPreload({ checkoutPaxDesktop }) {
    useEffect(() => {
        checkoutPaxDesktop?.preload();
    }, []);
}
export function useFlightDetailsDesktopEffectsAiSummary({ brandedFareIndex, flightKey, isMetaUser, id, urlParams, clientFetch }) {
    useEffect(() => {
        if (isFeatureRunningClientSide("FLIGHTS_OFFER_HIGHLIGHTS_DRY_RUN") &&
            !isMetaUser &&
            !brandedFareIndex &&
            !!id &&
            !!flightKey) {
            const queryParams = new URLSearchParams(urlParams);
            queryParams.set("offerToken", id);
            queryParams.set("offerKey", flightKey);
            void clientFetch(`/api/search/offer-ai-summary?${queryParams.toString()}`);
        }
    }, [brandedFareIndex, flightKey, isMetaUser, id]);
}
